import { useCallback, useMemo, useState } from 'react';

import { DepartureInventory } from '~/types/tours/inventory';

import { inventoryAtDate } from './inventorySnapshot';

export default function useInventorySnapshot(inventory?: DepartureInventory) {
  const key = inventory ? `${inventory.serviceId}:${inventory.departureId}` : '';
  const [selection, setSelection] = useState<{ key: string; date: number }>();
  const date = selection?.key === key ? selection.date : undefined;
  const onDateChange = useCallback((date: number) => setSelection({ key, date }), [key]);
  const snapshot = useMemo(() => inventoryAtDate(inventory, date), [inventory, date]);

  return { snapshot, date, onDateChange };
}
